import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "userCart";

export const userCartService = {
    getAllByUserId,
    updateDiscount,
    complete
};

function getAllByUserId(query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAllByUserId/?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function updateDiscount(id: number, code: string) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/updateDiscount/?id=${id}&code=${code}`, requestOptions).then(handleResponse);
}

function complete(id: number) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/complete/?id=${id}`, requestOptions).then(handleResponse);
}